import { useEffect, useRef } from "react";
import { CommonPage, Content, PageTitle } from "common/Grid";
import { toast } from "react-toastify";
import { StaffUserForm } from "../Common/MainForm";
import { useUpdateStaffUserMutation } from "store/action/staffUserApi";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { captureComponentError } from "utils/sentry";

const EditStaffUser = () => {
  const [updateStaffUser, { isLoading }] = useUpdateStaffUserMutation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const successRef = useRef(false);

  useEffect(() => {
    return () => {
      if (!successRef.current) {
        toast.dismiss();
      }
    };
  }, []);

  if (!state?.user) {
    return <Navigate to="/staff-user" replace />;
  }

  const { user } = state;

  const handleSubmit = async (userInput) => {
    try {
      const { phonePrefix, phoneNumber, ...rest } = userInput;
      const fullPhone = phoneNumber ? `${phonePrefix}${phoneNumber}` : undefined;

      const payload = {
        ...rest,
        email: rest?.email?.toLowerCase(),
        phoneNumber: fullPhone,
        password: rest.password === "" ? undefined : rest.password,
        pin: rest.pin || undefined,
        role: rest.role || undefined,
        username: rest.username || undefined,
        siteid: rest.siteid || undefined,
        _id: user._id,
      };
      const response = await updateStaffUser({ body: payload }).unwrap();
      successRef.current = true;
      toast.success(response?.message || "Staff user updated successfully");
      navigate("/staff-user");
    } catch (error) {
      captureComponentError(error, { component: "EditStaffUser", action: "handleSubmit" });
      toast.error(error?.data?.message || "Something went wrong!");
    }
  };

  return (
    <CommonPage>
      <Content>
        <PageTitle title="Update Staff User" />
        <StaffUserForm
          defaultValues={user}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          isEdit={true}
        />
      </Content>
    </CommonPage>
  );
};

export default EditStaffUser;
